<template>
  <div>
    <Nav></Nav>
    <div>
      <img
        style="width: 100%; height: 300px"
        src="../assets/images/about/about_banner.png"
        alt=""
      />
    </div>
    <div class="about-main bbg">
      <div class="wrap">
        <div class="about-logo">
          <img src="../assets/images/about/about_logo.png" alt="" />
        </div>
        <div class="about-main1">
          <div class="text-box">
            <img src="../assets//images/about/about_left.png" alt="">
          </div>
          <div class="text">
           <img src="../assets/images/about/about_gong.png" alt="">
           <p>北京博奥网络教育科技股份有限公司</p>
           <img src="../assets/images/about/about-ye.png" alt="">
           <p>北京·中粮广场、北京·东坝、湖北武汉、福建福州、宁夏银川</p>
           <img src="../assets/images/about/about_yan.png" alt="">
           <p>北京·东坝、河北燕郊</p>
           <img src="../assets/images/about/about_ye1.png" alt="">
           <p>人员信息化管理、职业技能培训、无纸化考核、资格水平评价</p>
           <img src="../assets/images/about/about_hang.png" alt="">
           <p>交通、住建、食品安全、医疗卫生、安全评价、环保、民政、纪检等领域</p>
           <img src="../assets/images/about/about_fu.png" alt="">
           <p>国家部委、企事业单位、行业协会、培训考核机构等</p>
           <img src="../assets/images/about/about_he.png" alt="">
           <p>2200+（省级、市级、区县级）</p>
           <img src="../assets/images/about/about_fu1.png" alt="">
           <p>8000W+</p>

          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from '@/components/topNav'
import Footer from '@/components/footer'
import config from '../../config/index';
export default {
  components: {
    Nav,
    Footer
  },
  data () {
    return {
      formData: {
        name: '',
        phone: '',
        qq: '',
        email: '',
        msg: ''
      },
      ruleValidate: {
        name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        email: [
          { required: true, message: '邮箱不能为空', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          {
            pattern: '^[1][3578][0-9]{9}$',
            message: '电话格式不正确',
            trigger: 'blur'
          }
        ],
        qq: [
          { required: true, message: '电话不能为空', trigger: 'blur' },
          {
            pattern: '^[1-9][0-9]{4,}',
            message: 'qq格式不正确',
            trigger: 'blur'
          }
        ],
        msg: [{ required: true, message: '留言不能为空', trigger: 'blur' }]
      }
    }
  },
  watch: {
    $route (to, from) {}
  },
  mounted () {
    // const config = require('../../config/index')
    // const isProduction = process.env.NODE_ENV === 'production'
    // console.log('isProduction',isProduction,config.build.assetsPublicPath);

    // 创建script标签，引入外部文件
    // let script = document.createElement('script')
    // script.type = 'text/javascript'
    // script.src =
    //   'http://api.map.baidu.com/getscript?v=2.0&ak=lUQQ1aR49wpldySfn4h7qMCa&services=&t=20171031174121'
    // document.getElementsByTagName('head')[0].appendChild(script)
    // setTimeout(() => {
    //   this.baiDuMap()
    // }, 2000)
  },
  methods: {
    baiDuMap () {
      let maoIcon = '../assets/images/about/address-logo.png'
      var map = new BMap.Map('allmap')
      var point = new BMap.Point(116.436747, 39.912995)
      map.centerAndZoom(point, 15)
      map.addControl(new BMap.NavigationControl())
      map.setMapStyle({
        style: 'pink'
      })
      var pt = new BMap.Point(116.436747, 39.912995)

      var bmapIcon = (process.env.NODE_ENV === 'production' ? '..' + config.build.assetsPublicPath: '../') + 'static/logo-small.svg'
      var myIcon = new BMap.Icon(
        // "../assets/images/about/logo-small.svg",
        bmapIcon,
        new BMap.Size(60, 30)
      )
      var marker2 = new BMap.Marker(pt, {
        icon: myIcon
      })
      map.addOverlay(marker2)
    },
    submit () {
      this.$refs['formData'].validate((valid) => {
        if (!valid) {
          this.$Message.error('请按提示输入信息!')
          return
        }

        this.axios({
          method: 'POST',
          url: '/api/About/AddLeavemsg',
          data: this.formData
        })
          .then((res) => {
            if (!res.data.success) {
              this.$Message.error('提交失败，请稍后重试。')
              return
            }
            this.$Message.success('提交成功。')
            this.$refs['formData'].resetFields()
          })
          .catch((err) => {
            console.log(err)
          })
      })
    }
  }
}
</script>
<style lang="less" scoped>
.bom-box {
  display: flex;
  .flex1 {
    flex: 1;
  }
  .form {
    width: 100%;
    background-image: url(../assets/images/about/form_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    color: #fff;
    .form-title {
      display: block;
      margin-top: 55px;
      margin-bottom: 30px;
      font-size: 25px;
          text-align: center;
    }
    .item {
      display: flex;
      margin-bottom: 50px;
      .submit {
        width: 160px;
        height: 44px;
        line-height: 44px;
        background: #b00000;
        text-align: center;
        border-radius: 6px;
        cursor: pointer;
        margin: auto;
        font-size: 18px;
      }
      .lable {
        display: inline-block;
        width: 80px;
        font-size: 20px;
        text-align: center;
      }
      input {
        width: 200px;
        height: 46px;
        border: 1px solid #ffffff;
        background: rgba(255, 255, 255, 0.3);
        font-size: 20px;
        color: #fff;
        padding-left: 6px;
        border-radius: 4px;
      }
      textarea {
        width: 490px;
        height: 120px;
        border: 1px solid #ffffff;
        background: rgba(255, 255, 255, 0.3);
        font-size: 20px;
        color: #fff;
        padding-left: 6px;
        border-radius: 4px;
      }
    }
  }
  .map {
    width: 50%;
    height: 660px;
    #allmap {
      width: 100%;
      height: 100%;
    }
  }
}
.bbg {
  width: 100%;
  background-image: url(../assets/images/about/main_bbg.png);
  background-size: 100%;
  height: auto;
}
.bbg2 {
  padding: 50px 0;
  background-image: url(../assets/images/about/bbg2.png);
}
.wrap {
  width: 1200px;
  margin: auto;
  .about-logo {
    padding: 80px 0 40px 0;
    text-align: center;
  }
  .about-main1 {
    width: 100%;
    height: 550px;
    display: flex;
    justify-content:space-around;
    // background-color: #ccc;
    margin-bottom: 200px;
    .text-box {
      width: 45%;
      margin-left: 80px;
      margin-top: 45px;
    }
    .text {
      width: 55%;
      margin-left: 25px;
      box-sizing: border-box;
      padding: 0px 30px 0 30px;
      font-size: 16px;
      font-family: PingFang-SC-Medium;
      line-height: 27px;
      p{
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #333333;
        margin-bottom: 5px;
        letter-spacing: 1px;
      }
    }
  }
}
input:focus,
textarea:focus {
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/views/about.vue